/*
semsomi AB
Copyright (c) 2016-2017
All rights reserved
*/

import { createStore,applyMiddleware } from 'redux';
import reducers from './reducers';
import thunk from 'redux-thunk';
import api from './middlewares/api.js'

const store = createStore(reducers,applyMiddleware(thunk,api));

export default store;
